var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8799 2.13855H20.6098V17.8623H11.8799V2.13855Z",
    fill: "#FD6020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4344 10.0001C12.4333 8.48551 12.776 6.99053 13.4366 5.62837C14.0973 4.26621 15.0585 3.07258 16.2475 2.13787C14.7757 0.978382 13.0081 0.25732 11.1468 0.0571007C9.28547 -0.143118 7.4055 0.185585 5.72174 1.00564C4.03799 1.8257 2.61839 3.10402 1.62521 4.69449C0.632036 6.28497 0.105347 8.12343 0.105347 9.99974C0.105347 11.8761 0.632036 13.7145 1.62521 15.305C2.61839 16.8955 4.03799 18.1738 5.72174 18.9938C7.4055 19.8139 9.28547 20.1426 11.1468 19.9424C13.0081 19.7422 14.7757 19.0211 16.2475 17.8616C15.0586 16.927 14.0974 15.7335 13.4368 14.3714C12.7762 13.0094 12.4334 11.5145 12.4344 10.0001Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3868 10.0001C32.3869 11.8764 31.8602 13.7149 30.8671 15.3054C29.8739 16.8959 28.4544 18.1742 26.7706 18.9943C25.0869 19.8144 23.2069 20.1431 21.3456 19.943C19.4843 19.7428 17.7167 19.0218 16.2449 17.8623C17.4324 16.9265 18.3924 15.7326 19.0525 14.3707C19.7126 13.0088 20.0556 11.5145 20.0556 10.0004C20.0556 8.48636 19.7126 6.99204 19.0525 5.63017C18.3924 4.2683 17.4324 3.07442 16.2449 2.13857C17.7166 0.979158 19.4842 0.258148 21.3454 0.0579483C23.2067 -0.142252 25.0866 0.186435 26.7703 1.00644C28.454 1.82645 29.8736 3.1047 30.8668 4.69509C31.86 6.28548 32.3867 8.12386 32.3868 10.0001Z",
    fill: "#F59E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6b86f70d7b90d09b645ae80bd13af031.svg";
export { ForwardRef as ReactComponent };